import { render, staticRenderFns } from "./CustomerDepartmentEdit.vue?vue&type=template&id=edadc8ea&"
import script from "./CustomerDepartmentEdit.vue?vue&type=script&lang=ts&"
export * from "./CustomerDepartmentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports